import {CONSTANTS} from '@/config/constants';

export default {
  name: 'facebookFooter',
  data () {
    return {
      startYear: '2013',
      currentYear: String(new Date().getFullYear()),
      links: [
        {
          title: 'Terms of Use',
          url: CONSTANTS.APP_PTD_SITE_URL + '/terms-of-use'
        },
        {
          title: 'Privacy Police',
          url: CONSTANTS.APP_PTD_SITE_URL + '/privacy-policy'
        }
      ]
    }
  }
}
